import React, {
  useState, useEffect, useCallback, useLayoutEffect, useRef
} from 'react';
import axios from 'axios';
import ShowItem from './ShowItem';
import styles from './ShowList.module.css';

const ShowList = ({
  userId,
  restartAutoScroll,
  propShows,
  isAuthenticated,
  highlightedShowId,
  sendEvent,
  onOpenAuthModal,
  searchQuery = ''
}) => {
  const [shows, setShows] = useState([]);
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const firstLoad = useRef(true);

  useEffect(() => {
    const fetchShows = async () => {
      try {
        if (propShows) {
          setShows(propShows);
        } else {
          const response = await axios.get('/api/concerts');
          setShows(response.data);
        }
        setIsLoading(false);
        if (firstLoad.current && restartAutoScroll) {
          restartAutoScroll();
          firstLoad.current = false;
        }
      } catch (error) {
        setIsLoading(false);
      }
    };
    fetchShows();
  }, [propShows, restartAutoScroll]);

  useLayoutEffect(() => {
    if (highlightedShowId && shows.length > 0) {
      const el = document.getElementById(`show-${highlightedShowId}`);
      if (el) el.scrollIntoView({ behavior: 'auto', block: 'center' });
    }
  }, [highlightedShowId, shows]);

  const handlePlay = useCallback((id) => {
    setCurrentlyPlaying((prev) => (prev === id ? null : id));
  }, []);

  const handleTagClick = (tag) => {
    setSelectedTags((prevTags) => {
      if (prevTags.includes(tag)) return prevTags.filter((t) => t !== tag);
      return [...prevTags, tag];
    });
  };

  // фільтрація по обраним тегам:
  // жанр / місто / артист-стікер / спецгості / саппорт
  const filteredByTags =
    selectedTags.length > 0
      ? shows.filter((s) =>
          selectedTags.every(
            (tag) =>
              s.genre === tag ||
              s.city === tag ||
              s.artistSticker === tag ||
              (s.specialGuests || []).includes(tag) ||
              (s.supportActs || []).includes(tag)
          )
        )
      : shows;

  // пошук
  const searchShows =
    searchQuery.trim() === ''
      ? filteredByTags
      : filteredByTags.filter((s) =>
          [
            s.title,
            s.artist,
            s.genre,
            s.city,
            s.venue,
            s.date,
            s.timeStart,
            s.artistSticker,
            ...(s.specialGuests || []),
            ...(s.supportActs || []),
          ]
            .join(' ')
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );

  return (
    <div className={`${styles.showList} ${!isLoading ? styles.visible : ''}`}>
      {isLoading ? (
        <div className={styles.listSpinnerContainer}>
          <div className={styles.listSpinner}></div>
        </div>
      ) : (
        searchShows.map((show) => (
          <ShowItem
            key={show.id}
            id={show.id}
            highlighted={show.id === highlightedShowId}

            /* концертні поля */
            coverImage={show.coverImage}
            title={show.title}
            genre={show.genre}
            artist={show.artist}
            specialGuests={show.specialGuests}
            supportActs={show.supportActs}
            city={show.city}
            venue={show.venue}
            date={show.date}
            timeStart={show.timeStart}
            artistSticker={show.artistSticker}

            /* мапінг цін */
            priceTier1={show.priceTier1}
            priceTier2={show.priceTier2}

            /* логіка */
            isPlaying={currentlyPlaying === show.id}
            onPlay={handlePlay}
            onTagClick={handleTagClick}
            selectedTags={selectedTags}
            isAuthenticated={isAuthenticated}
            sendEvent={sendEvent}
	    onOpenAuthModal={onOpenAuthModal}
          />
        ))
      )}
    </div>
  );
};

export default ShowList;


